export const teamMembers = [
  {
    id: 'chon',
    name: 'Chonladet (Chon)',
    role: 'Co-Founder & Developer',
    bio: 'A skilled full-stack developer who combines technical expertise with user-friendly design to create innovative wedding tech solutions.',
    image: '/img/about-us/chon.jpg',
  },
  {
    id: 'fluke',
    name: 'Narathat (Fluke)',
    role: 'Co-Founder & Sales',
    bio: "A strategic business leader focused on understanding and meeting couples' needs. His industry insights and customer-first approach drive our growth and product development.",
    image: '/img/about-us/fluke.jpg',
  },
  {
    id: 'benz',
    name: 'Tanathorn (Benz)',
    role: 'Solution Sale Engineer',
    bio: 'Bridges technical capabilities with client vision, tailoring onboarding plans and guiding couples toward the right digital experiences for their celebration.',
    image: '/img/about-us/benz.jpg',
  },
];
